define('views/filter-header-rent',["exports", "common", "controls/calendar2", "controls/range", "controls/switcher", "controls/switcher-multi", "./filter-header"], function (_exports, _common, _calendar, _range, _switcher, _switcherMulti, _filterHeader) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _calendar = _interopRequireDefault(_calendar);
  _range = _interopRequireDefault(_range);
  _switcher = _interopRequireDefault(_switcher);
  _switcherMulti = _interopRequireDefault(_switcherMulti);
  _filterHeader = _interopRequireDefault(_filterHeader);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
  var _default = _exports.default = _filterHeader.default.extend({
    initialize(options) {
      _filterHeader.default.prototype.initialize.call(this, options);
      var listState = this.listState;
      {
        var dateFilter = this.el.querySelector('.filter-date');
        this.dateCalendar = new _calendar.default({
          el: dateFilter.querySelector('.c-datepicker'),
          cssClass: 'c-datepicker--dropdown',
          model: this.listState
        });
        this.listenTo(this.dateCalendar, 'done', () => {
          dateFilter.querySelector('.filter__btn').click();
        });
        this.dateCalendar.init();
        dateFilter.addEventListener('show.bs.dropdown', () => {
          this.dateCalendar.show();
        });
        dateFilter.addEventListener('hide.bs.dropdown', () => {
          this.dateCalendar.hide();
        });
      }
      {
        var guestsFilter = this.el.querySelector('.filter-guests');
        guestsFilter.querySelector('.filter__dropdown-menu').addEventListener('click', ev => ev.stopPropagation());
        this.guests = new _switcher.default(guestsFilter.querySelector('.filter-guests__control'), {
          model: listState,
          prop: 'guests',
          onChange() {
            guestsFilter.querySelector('.filter__btn').click();
          }
        });
      }
      {
        var budgetFilter = this.el.querySelector('.filter-budget');
        budgetFilter.querySelector('.filter__dropdown-menu').addEventListener('click', ev => ev.stopPropagation());
        budgetFilter.addEventListener('shown.bs.dropdown', () => {
          if (this.budget) {
            return;
          }
          this.budget = new _range.default(budgetFilter.querySelector('.control-range'), {
            min: 0,
            model: listState,
            delayProp: 'budget$delay',
            max: 1000,
            maxProp: '_budget$max',
            step: 50,
            stepProp: '_budget$step',
            startProp: 'budget$start',
            startFmt: (value = 0) => (0, _common.formatPrice)(value),
            endProp: 'budget$end',
            endFmt: end => {
              var max = listState.get('_budget$max');
              if (end > 0 && end < max) {
                return (0, _common.formatPrice)(end);
              } else {
                var symbol = (0, _common.formatPrice)(0).replace('0', '');
                var str = (0, _common.formatPrice)(max);
                var p = str.indexOf(symbol);
                return p > 0 ? `${str.substring(0, p)}+${str.substring(p)}` : `${str}+`;
              }
            },
            dependencyProps: ['currency']
          });
        });
      }
      {
        var starsFilter = this.el.querySelector('.filter-stars');
        starsFilter.querySelector('.filter__dropdown-menu').addEventListener('click', ev => ev.stopPropagation());
        starsFilter.addEventListener('shown.bs.dropdown', () => {
          listState.updateQuantity('stars');
        });
      }
      {
        var amenitiesFilter = this.el.querySelector('.filter-amenities');
        amenitiesFilter.querySelector('.filter__dropdown-menu').addEventListener('click', ev => ev.stopPropagation());
        amenitiesFilter.addEventListener('shown.bs.dropdown', () => {
          listState.updateQuantity('amenities');
        });
      }
      {
        var neighborhoodFilter = this.el.querySelector('.filter-neighborhood');
        if (neighborhoodFilter) {
          neighborhoodFilter.querySelector('.filter__dropdown-menu').addEventListener('click', ev => ev.stopPropagation());
          neighborhoodFilter.addEventListener('shown.bs.dropdown', () => {
            listState.updateQuantity('neighborhood');
          });
          neighborhoodFilter.querySelector('.control-neighborhood .bounds .close').addEventListener('click', () => {
            listState.unset('bounds');
          });
        }
      }
      {
        var moreFilter = this.el.querySelector('.filter-more');
        var moreToggle = moreFilter.querySelector('.filter__btn');
        moreFilter.querySelector('.filter__dropdown-menu').addEventListener('click', ev => ev.stopPropagation());
        moreFilter.addEventListener('shown.bs.dropdown', () => {
          listState.updateQuantity('more');
        });
        this.bathrooms = new _switcherMulti.default(moreFilter.querySelector('.control-bathrooms'), {
          model: listState,
          onChange() {
            moreToggle.click();
          }
        });
        this.bedrooms = new _switcherMulti.default(moreFilter.querySelector('.control-bedrooms'), {
          model: listState,
          onChange() {
            moreToggle.click();
          }
        });
      }
    }
  });
});//# sourceMappingURL=filter-header-rent.js.map
;
